import { jsx } from "react/jsx-runtime";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { validateTidalLicense } from "../../base/index.js";
function AddCircleOutline(props) {
  return /* @__PURE__ */ jsx(
    AddCircleOutlineIcon,
    {
      "data-testid": "AddCircleOutline",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "AddCircleOutline",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
AddCircleOutline.tidalIconMeta = {
  categories: "cancel,informative",
  name: "AddCircleOutline"
};
validateTidalLicense();
export {
  AddCircleOutline
};
//# sourceMappingURL=AddCircleOutline.js.map
